import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { exportToExcel, exportToCSV } from "../utils/exportUtils";
import { Dropdown, Space } from "antd";
import { DownloadOutlined, FileExcelOutlined, FileTextOutlined, LoadingOutlined } from "@ant-design/icons";

export default function CSV({
  columns,
  list,
  title,
  className,
  btnName,
  notButton,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  if (!Array.isArray(list) || !Array.isArray(columns)) return null;

  const handleExport = async (type) => {
    setLoading(true);
    // Use setTimeout to ensure the loading state is rendered before the blocking xlsx processing starts
    setTimeout(() => {
      try {
        const dataToExport = list.map((item) => {
          const data = {};
          columns.forEach((column) => {
            if (column.csvOff) return;

            let value = "";
            if (column.renderCsv && typeof column.renderCsv === "function") {
              value = column.dataIndex
                ? column.renderCsv(item[column.dataIndex], item)
                : column.renderCsv(item);
            } else if (column.dataIndex) {
              value = item[column.dataIndex];
            } else {
              value = item;
            }

            // Clean up value if it's an object or null
            if (typeof value === "object" && value !== null) {
              value = JSON.stringify(value);
            }

            data[column.title] = value;
          });
          return data;
        });

        const fileName = title || "data";
        if (type === "excel") {
          exportToExcel(dataToExport, fileName);
        } else {
          exportToCSV(dataToExport, fileName);
        }
      } catch (error) {
        console.error("Export failed:", error);
      } finally {
        setLoading(false);
      }
    }, 100);
  };

  const items = [
    {
      key: "excel",
      label: "Excel (.xlsx)",
      disabled: loading,
      icon: <FileExcelOutlined />,
      onClick: () => handleExport("excel"),
    },
    {
      key: "csv",
      label: "CSV (.csv)",
      disabled: loading,
      icon: <FileTextOutlined />,
      onClick: () => handleExport("csv"),
    },
  ];

  const buttonContent = (
    <Space>
      {loading ? <LoadingOutlined /> : <DownloadOutlined />}
      {btnName ? btnName : t("common.exportData")}
    </Space>
  );

  return (
    <Dropdown menu={{ items }} placement="bottomRight" arrow disabled={loading}>
      {notButton ? (
        <a className={`cursor-pointer ${className}`} onClick={(e) => e.preventDefault()}>
          {buttonContent}
        </a>
      ) : (
        <Button color="gray" className={className} loading={loading}>
          {buttonContent}
        </Button>
      )}
    </Dropdown>
  );
}
